module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "bg-color"
  }, [_c('div', {
    staticClass: "container blog-display"
  }, [_c('div', {
    staticClass: "inner-blog"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "about-blog"
  }, [_c('h1', {
    staticClass: "blog_title"
  }, [_vm._v(_vm._s(_vm.fetchedData.attributes.title))]), _vm._v(" "), _c('h3', {
    staticClass: "blog_date_author"
  }, [_vm._v(_vm._s(_vm._f("convertDate")(_vm.fetchedData.attributes.event_date)) + " - " + _vm._s(_vm.fetchedData.attributes.published_by))]), _vm._v(" "), _c('div', {
    staticClass: "blog_content"
  }, [_c('big', {
    domProps: {
      "innerHTML": _vm._s(this.$options.filters.convertUrlImage(_vm.fetchedData.attributes.description))
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('popular', {
    model: {
      value: (_vm.popular),
      callback: function($$v) {
        _vm.popular = $$v
      },
      expression: "popular"
    }
  })], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-09421ece"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BlogDetails.vue
// module id = 296
// module chunks = 1